"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPOTIFY_FOLLOW_URL = exports.PLACEHOLDER_DIMENSIONS = exports.DEFAULT_SIZES = void 0;
exports.DEFAULT_SIZES = {
    largeWithCounter: {
        width: 228,
        height: 58,
        type: 'detail',
    },
    large: {
        width: 170,
        height: 60,
        type: 'detail',
    },
    smallWithCounter: {
        width: 162,
        height: 27,
        type: 'basic',
    },
    small: {
        width: 92,
        height: 27,
        type: 'basic',
    },
};
exports.PLACEHOLDER_DIMENSIONS = {
    basic: { width: 156, height: 25 },
    detail: { width: 225, height: 56 },
};
exports.SPOTIFY_FOLLOW_URL = 'https://open.spotify.com/follow/1/';
//# sourceMappingURL=constants.js.map